import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import { loader, toastr } from '../CommonActions'
import { auth } from '../../../services/auth.service';

export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_SEND = 'GET_USERS_SEND';
export const GET_USERS_ERROR = 'GET_USERS_ERROR';
export const SELECT_USER = 'SELECT_USER';
export const ADD_ADMIN_USER = 'ADD_ADMIN_USER';
export const GET_PERMISSIONS = 'GET_PERMISSIONS';
export const DELETE_ADMIN_USER = 'DELETE_ADMIN_USER';
export const UPDATE_ADMIN_USER = 'UPDATE_ADMIN_USER';

const successColor =  "success";
const errorColor = "danger";
const warningColor = "warning";

export function fetchUsers(role) {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.get(`${ROOT_API_URL}/ManageUsers/GetUsersByRole?role=${role}`, { headers: auth.authHeader() })
			.then((response) => {
				dispatch({
					type: GET_USERS_SUCCESS,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((error) => {
				var err = "Network Connection Error"; 
				dispatch(loader(false));		
				dispatch(toastr(true,err, errorColor));
			});
	};
}

export function getPermissions(role) {
    return function (dispatch) {
		axios
			.get(`${ROOT_API_URL}/ManageUsers/GetPermissions?role=${role}`, { headers: auth.authHeader() })
			.then((response) =>
				dispatch({
					type: GET_PERMISSIONS,
					permissions: response.data
				})
			)
			.catch((response) => {
				console.log(response);
			});
	};
}

export function addAdminUser(user) {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManageUsers/CreateInternalUser`, user, { headers: auth.authHeader() })
			.then(function(response){	
				if (response && response.data && response.data.issuccess) 
				{
					dispatch({
						type: ADD_ADMIN_USER,
						payload: response.data.userList,
					});
					var success = response && response.data ? response.data.message : "User Created Successfully"; 
					dispatch(toastr(true,success, successColor));
				}
				else {
					var err = response && response.data ? response.data.message : "User Already Exists"; 
					dispatch(toastr(true,err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : "Network Connection Error"; 
				dispatch(loader(false));		
				dispatch(toastr(true,err, errorColor));
			});
	};
}

export function deleteUser(user) {

	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManageUsers/DeleteUser`, user, { headers: auth.authHeader() })
			.then((response) =>
			{
			if (response && response.data && response.data.issuccess) 
				{
					dispatch({
						type: DELETE_ADMIN_USER,
					payload: response.data.userList
					});	
					var success = response && response.data ? response.data.message : "User De-activated Successfully"; 
					dispatch(toastr(true,success, successColor));
				}
				else {
					var err = response && response.data ? response.data.message : "Error Occured"; 
					dispatch(toastr(true,err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				dispatch(loader(false));

				var err = response && response.data ? response.data.message : "Network Connection Error"; 
				dispatch(toastr(true,err, errorColor));
			});
	};
}

export function updateAdminUser(user) {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManageUsers/UpdateInternalUser`, user, { headers: auth.authHeader() })
			.then((response) => {
				console.log("update response", response)
				if (response && response.data && response.data.issuccess) 
				{
					dispatch({
						type: UPDATE_ADMIN_USER,
						payload: response.data.userList
					});	
					var success = response && response.data ? response.data.message : "User Updated Successfully"; 
					dispatch(toastr(true,success, successColor));
				}
				else {
					var err = response && response.data ? response.data.message : "Error Occured"; 
					dispatch(toastr(true,err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				dispatch(loader(false));

				var err = response && response.data ? response.data.message : "Network Connection Error"; 
				dispatch(toastr(true,err, errorColor));
			});
	};
}
